module.exports = __webpack_public_path__ + "static/media/1.290fb81f.jpg";